import { FormattedMessage, useIntl } from "react-intl";
import MainCreationForm from "components/forms/MainCreationForm";
import { Button, Form, Input, Select } from "antd";
import React from "react";
import PhoneNumberField from "components/fields/PhoneNumberField";

import { UserFormProps } from "./types";
import { useUserFormRoleOptions } from "./hooks";

export const UserForm = <IsVenueUser extends boolean>({
  loading,
  phoneIsReadOnly,
  isReadOnly,
  isVenueUser,
  ...props
}: UserFormProps<IsVenueUser>): React.ReactElement => {
  const intl = useIntl();
  const roleOptions = useUserFormRoleOptions(isVenueUser);

  return (
    <MainCreationForm disabled={loading} {...props}>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "First Name",
        })}
        name={["input", "firstName"]}
        required
      >
        <Input disabled={isReadOnly} />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Last Name",
        })}
        name={["input", "lastName"]}
        required
      >
        <Input disabled={isReadOnly} />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Phone Number",
        })}
        name={["input", "phoneNumber"]}
        required
      >
        <PhoneNumberField disabled={phoneIsReadOnly || isReadOnly} />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Permission Level",
        })}
        name={["input", "role"]}
        required
      >
        <Select disabled={!isVenueUser} options={roleOptions} />
      </Form.Item>
      {!isReadOnly && (
        <Form.Item>
          <Button type="primary" htmlType="submit" {...{ loading }}>
            <FormattedMessage defaultMessage="Submit" />
          </Button>
        </Form.Item>
      )}
    </MainCreationForm>
  );
};
